import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  SCHEDULE_RECURRING_APPOINTMENT_REQUEST,
  SCHEDULE_RECURRING_APPOINTMENT_SUCCESS,
  SCHEDULE_RECURRING_APPOINTMENT_FAILURE,
} = TherapistAction;

function* scheduleRecurringAppointment(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.scheduleRecurringAppointment,
      action.payload
    );
    if (response?.status === 200 || response?.status === 201) {
      yield put({ type: SCHEDULE_RECURRING_APPOINTMENT_SUCCESS, payload: response.data });
      
      // Clear getAllTherapistTaskReducer data when recurring appointment gets scheduled
      yield put({ type: TherapistAction.GET_ALL_THERAPIST_TASK_RESET });
    } else {
      console.error('Unexpected response status:', response?.status);
      throw response.data;
    }
  } catch (error) {
    console.error('Schedule Recurring Appointment Error:', error);
    yield put({ type: SCHEDULE_RECURRING_APPOINTMENT_FAILURE, payload: error });
  }
}

function* scheduleRecurringAppointmentSaga() {
  yield takeEvery(SCHEDULE_RECURRING_APPOINTMENT_REQUEST, scheduleRecurringAppointment);
}

export default scheduleRecurringAppointmentSaga;
